export const FORM_ACTIONS = {
	CREATE: 'FORM_CREATE'
}
